import "swiper/css";
import Icon from "./ui/Icon";
import { useEffect, useState } from "react";
import { Pagination } from "swiper/modules";
import { Sheet, SheetContent } from "./ui/sheet";
import { Swiper, SwiperSlide } from "swiper/react";
import ManagerCard from "../components/ManagerCard";
import { Link, useLocation } from "react-router-dom";
import miniLogo from "../assets/images/Base-pic.png";
import { highlightText } from "../utils/TextHighLighter";
import { useSearchContext } from "./Header/SearchContext";
import InstitutionCard from "../components/InstitutionCard";
import CategoriesMenuContent from "../components/Header/CategoriesMenuContent";


type MobileBottomNavProps = {
  categories?: any[];
  extraContent?: React.ReactNode;
  persons: any[];
  loadMorePersons: () => Promise<void>;
  loadingMorePersons: boolean;
  hasMorePersons: boolean;
  isPersonsLoading: boolean;
  projects: any[];
  loadMoreProjects: () => Promise<void>;
  loadingMoreProjects: boolean;
  hasMoreProjects: boolean;
  isProjectsLoading: boolean;
};

export default function MobileBottomNave({
  categories = [],
  extraContent,
  persons,
  loadMorePersons,
  loadingMorePersons,
  hasMorePersons,
  isPersonsLoading,
  projects,
  loadMoreProjects,
  loadingMoreProjects,
  hasMoreProjects,
  isProjectsLoading,
}: MobileBottomNavProps) {
  const location = useLocation();
  const [visiblePersons, setVisiblePersons] = useState(3);
  const [visibleProjects, setVisibleProjects] = useState(3);
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const { query, isOpen, setIsOpen } = useSearchContext();
  const handlePersonsLoadMore = async () => {
    if (visiblePersons + 4 <= persons.length) {
      setVisiblePersons((p) => p + 4);
      return;
    }

    await loadMorePersons();
  };
  const handleProjectsLoadMore = async () => {
    if (visibleProjects + 4 <= projects.length) {
      setVisibleProjects((p) => p + 4);
      return;
    }

    await loadMoreProjects();
  };

  const isSearchActive = isOpen;
  useEffect(() => {
    if (!isSheetOpen) {
      setVisiblePersons(3);
      setVisibleProjects(3);
    }
  }, [isSheetOpen]);
  const handleCloseSearch = () => {
    if (isOpen) setIsOpen(false);
  };

  const navItems = [
    {
      key: "categories",
      icon: "Category",
      label: "دسته‌بندی",
      action: () => {
        handleCloseSearch();
        setIsSheetOpen(true);
      },
    },
    {
      key: "home",
      icon: "HomePage",
      label: "خانه",
      to: "/home",
      active: !isSearchActive && location.pathname.startsWith("/home"),
    },
    {
      key: "menu",
      icon: "Doc",
      label: "منو",
      to: "/news",
      active: !isSearchActive && location.pathname.startsWith("/news"),
    },
    {
      key: "search",
      icon: "Search2",
      label: "جستجو",
      action: () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        setTimeout(() => {
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        }, 100);
        setIsOpen(true);
      },
      active: isSearchActive,
    },
  ];

  return (
    <>
      {/* Navigation Bar */}
      <div className="relative w-full mb-5 flex items-center justify-center px-4">
        <div
          className={`flex items-center gap-3 ${
            extraContent ? "w-full" : "w-[68%] md:w-[95%]"
          } px-3 h-[60px] bg-green-04/60 backdrop-blur rounded-[20px]`}
        >
          {extraContent ? <div className="shrink-0">{extraContent}</div> : null}

          <div className="flex items-center justify-around flex-1">
            {navItems.map((item) => {
              const isActive = item.active;
              const baseClass =
                "flex items-center justify-center size-[42px] rounded-2xl transition";
              const activeClass = isActive
                ? "bg-green-04 text-white"
                : "text-white/80";
              const ButtonContent = (
                <Icon icon={item.icon} className="size-5 shrink-0" />
              );

              return item.to ? (
                <Link
                  key={item.key}
                  to={item.to}
                  onClick={handleCloseSearch}
                  className={`${baseClass} ${activeClass}`}
                >
                  {ButtonContent}
                </Link>
              ) : (
                <button
                  key={item.key}
                  onClick={item.action}
                  className={`${baseClass} ${activeClass}`}
                >
                  {ButtonContent}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <Sheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
        <SheetContent
          side="bottom"
          className="pt-5 px-5 bg-complement-01 h-[85vh] rounded-t-[30px] overflow-hidden border-none flex flex-col"
        >
          <div className="w-full bg-complement-01 flex flex-col items-center flex-shrink-0 pt-2 z-10 border-b border-green-02/5">
            <Link
              to="/founder"
              onClick={() => {
                handleCloseSearch();
                setIsSheetOpen(false);
              }}
              className="flex flex-col items-center justify-center cursor-pointer"
            >
              <div className="size-[123px] bg-green-01 overflow-hidden">
                <img
                  src={miniLogo}
                  alt="mini logo"
                  className="object-cover background-home-image"
                />
              </div>
              <span className="text-center text-green-05">
                <p className="text-[10px] font-semibold font-kahroba opacity-80">
                  {highlightText("حجة الاسلام و المسلمین", query)}
                </p>
                <h4 className="text-[16px] font-black font-kahroba my-0.5">
                  {highlightText("ســید جــواد شهرســتانی", query)}
                </h4>
                <p className="text-[10px] font-semibold font-kahroba opacity-80">
                  {highlightText(
                    "موسس و مدیر موسسه آل البیت علیهم اسلام",
                    query,
                  )}
                </p>
              </span>
            </Link>
          </div>

          <div
            className="flex-1 min-h-0 w-full bg-complement-01 flex flex-col"
            dir="rtl"
          >
            <div className="swiper-pagination-custom pb-3" />

            <div className="flex-1 min-h-0">
              <Swiper
                modules={[Pagination]}
                spaceBetween={10}
                slidesPerView={1}
                pagination={{
                  clickable: true,
                  el: ".swiper-pagination-custom",
                }}
                onSlideChange={() => {
                  setVisiblePersons(3);
                  setVisibleProjects(3);
                }}
                className="w-full h-full"
              >
                {/* اسلاید اول: دسته‌بندی */}
                <SwiperSlide className="w-full h-full overflow-y-auto no-scrollbar">
                  <CategoriesMenuContent
                    categories={categories}
                    searchQuery={query}
                    closeSheetMenu={() => setIsSheetOpen(false)}
                  />
                </SwiperSlide>

                {/* اسلاید دوم: مدیران */}
                <SwiperSlide className="w-full h-full overflow-y-auto no-scrollbar">
                  <div className="grid grid-cols-1 gap-2.5 w-full">
                    {isPersonsLoading ? (
                      <div className="flex justify-center py-8">
                        <div className="size-5 border-2 border-green-04 border-t-transparent rounded-full animate-spin" />
                      </div>
                    ) : persons.length > 0 ? (
                      persons
                        .slice(0, visiblePersons)
                        .map((person: any, index: number) => (
                          <ManagerCard
                            key={person.id || index}
                            person={person}
                            index={index}
                            isActive={false}
                            searchQuery={query}
                            onClick={() => {
                              handleCloseSearch();
                              setIsSheetOpen(false);
                            }}
                          />
                        ))
                    ) : (
                      <div className="text-center py-8 text-green-04 text-xs font-estedad">
                        اطلاعاتی یافت نشد
                      </div>
                    )}
                  </div>

                  {hasMorePersons && (
                    <div className="w-full flex items-center justify-center my-2.5">
                      <button
                        onClick={handlePersonsLoadMore}
                        disabled={loadingMorePersons}
                        className="text-[11px] font-medium bg-green-02 text-complement-06 font-estedad px-3 py-1 rounded-[10px]"
                      >
                        {loadingMorePersons ? (
                          <div className="size-3 border-2 border-green-04 border-t-transparent rounded-full animate-spin" />
                        ) : (
                          "بیشتر"
                        )}
                      </button>
                    </div>
                  )}
                </SwiperSlide>

                {/* اسلاید سوم: پروژه‌ها */}
                <SwiperSlide className="w-full h-full overflow-y-auto no-scrollbar">
                  <div className="grid grid-cols-1 gap-2.5 w-full">
                    {isProjectsLoading ? (
                      <div className="flex justify-center py-8">
                        <div className="size-5 border-2 border-green-04 border-t-transparent rounded-full animate-spin" />
                      </div>
                    ) : projects.length > 0 ? (
                      projects
                        .slice(0, visibleProjects)
                        .map((project: any, index: number) => (
                          <InstitutionCard
                            key={project.id || index}
                            project={project}
                            index={index}
                            isActive={false}
                            searchQuery={query}
                            onClick={() => {
                              handleCloseSearch();
                              setIsSheetOpen(false);
                            }}
                          />
                        ))
                    ) : (
                      <div className="text-center py-8 text-green-04 text-xs font-estedad">
                        اطلاعاتی یافت نشد
                      </div>
                    )}
                  </div>

                  {hasMoreProjects && (
                    <div className="w-full flex items-center justify-center my-2.5">
                      <button
                        onClick={handleProjectsLoadMore}
                        disabled={loadingMoreProjects}
                        className="text-[11px] font-medium bg-green-02 text-complement-06 font-estedad px-3 py-1 rounded-[10px]"
                      >
                        {loadingMoreProjects ? (
                          <div className="size-3 border-2 border-green-04 border-t-transparent rounded-full animate-spin" />
                        ) : (
                          "بیشتر"
                        )}
                      </button>
                    </div>
                  )}
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
